<!-- <div class="container-fluid" *ngIf="def" #> -->
    <!-- <app-info-detail-display *ngIf="detailType == 'info'" [info]="def"></app-info-detail-display> -->
    <!-- <app-dining-detail-display *ngIf="detailType == 'dining'" [dining]="def"></app-dining-detail-display> -->
    <app-section-detail-display *ngIf="detailType == 'section'" [section]="def"></app-section-detail-display>
    <!-- <app-news-detail-display *ngIf="detailType == 'news'" [news]="def"></app-news-detail-display> -->
<!-- </div> -->